




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PermissionsMatrixActionsEnum } from '../../../store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { isUserAllowed } from '../../../utils/rbac.util';
import { EntityTypes } from '../../../store/modules/module-tree/enums/module-tree.enums';
import { State } from 'vuex-class';
import { RootState } from '@/store/store';
import { GroupLevelAttributeWithSpec } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { toCapitalCase } from '@/jbi-shared/util/string.utils';
import { CourseSpecificGLATypes } from '@/jbi-shared/types/jtms.types';

/**
 * This component is only used for displaying props
 * propagated from AttributesList and "bubbling up" events.
 * No `v-model` is used here because ALL contextual data is
 * handled by AttributesList.
 *
 * Available events:
 * - `@toggleLock` and `@toggleRequired`
 * Tells parent to update spec, and re-render icons
 *
 * - `@addAttribute` and `@removeAttribute`
 * As the names suggest.
 */
@Component({})
export default class AttributeRow extends Vue {
  @Prop(Boolean) isRowDisabled!: boolean;
  @Prop() specItem!: GroupLevelAttributeWithSpec;
  @Prop({ default: false }) isSelected!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop() groupTypeName!: string;
  @Prop() groupId!: number;

  // allows component consumer to supply predefined classes
  @Prop() classes!: string | string[];

  @State((state: RootState) => state.rbac.groupTypesUserHasAccessTo)
  public groupTypesUserHasAccessTo!: string[];

  public isUserAllowed(
    action: PermissionsMatrixActionsEnum,
    module: string
  ): boolean {
    const instance = EntityTypes.GROUP + '_' + this.groupId;
    const groupTypeName = this.groupTypeName
      ? this.groupTypeName
      : this.groupTypesUserHasAccessTo[0];
    return this.isSettings
      ? isUserAllowed(
          action,
          module,
          EntityTypes.GROUP,
          groupTypeName,
          this.groupId
        )
      : true;
  }

  get PermissionsMatrixActionsEnum(): typeof PermissionsMatrixActionsEnum {
    return PermissionsMatrixActionsEnum;
  }

  get classNames(): string {
    if (typeof this.classes === 'string') {
      return this.classes;
    }

    if (Array.isArray(this.classes)) {
      return this.classes.join(' ');
    }

    return '';
  }

  /**
   * Image types cannot be required.
   * I haven't a clue why.
   * Please, update this comment if you know.
   */
  get isImageType(): boolean {
    return this.specItem.groupLevelAttributeType.type === 'image';
  }

  /**
   * Administration fee type GLAs should be required by default.
   * This attribute will trigger mailer service, and empty fields
   * would cause unforeseen issues in the backend.
   */
  get isAdminFeeType(): boolean {
    return (
      this.specItem.groupLevelAttributeType.type ===
      CourseSpecificGLATypes.ADMIN_FEE
    );
  }

  toCapitalCase(str: string): string {
    return toCapitalCase(str);
  }

  toggleRequired(): void {
    if (this.isRowDisabled) {
      return;
    }

    if (this.isImageType) {
      return;
    }

    this.specItem.groupLevelAttributeSpec.isRequired = !this.specItem
      .groupLevelAttributeSpec.isRequired;
    this.$emit('toggleRequired', this.specItem);
  }

  updateSelected(
    item: GroupLevelAttributeWithSpec,
    checkboxValue: boolean
  ): void {
    if (this.isRowDisabled) {
      return;
    }

    if (checkboxValue === true) {
      this.$emit('addAttribute', item);
    } else {
      this.$emit('removeAttribute', item);
    }
  }
}
